import { ExportData, FormList, HeaderTitle, Operation, OverItem, Thumbnails } from '@/components';
import { getSpuList, getSpuOver, postSpuUpdate } from '@/api';
import { calcPrice, parseJSON, toDateTime } from '@/utils/utils';
import React, { useState, useEffect } from 'react';
import { st_spu } from '@/utils/statetype';
import { message, Table, Switch, Button } from 'antd';
import { useTable } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import {
  DeleteOutlined,
  DownloadOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import SpuEdit from './components/SpuEdit';

const { statusObj, typeObj, kindObj, recommendObj } = st_spu;
function SpuList({ history }) {
  // const navigate = useNavigate();
  const [query, setQuery] = useState({});
  const [count, setCount] = useState([]);
  const [visible, setVisible] = useState(false);
  const [datas, setDatas] = useState({});

  const handleUpdate = (id, status) => {
    postSpuUpdate({
      body: {
        ids: [id],
        status,
      },
    }).then(() => {
      message.success('操作成功');
      flagFn();
    });
  };

  const columns = {
    id: '商品编号',
    name: '商品名称',
    thumb: {
      title: '封面图',
      render: e => <Thumbnails images={[e]} center />,
    },
    NOINDEX_status: {
      title: '商品状态',
      render: e => {
        const { status, type } = e || {};
        if (status === 100) {
          return type === 20 ? '认购中' : type === 30 ? '转拍中' : '拍卖中';
        } else if (status === 110) {
          return type === 20 ? '认购成功' : type === 30 ? '转拍成功' : '已拍得';
        }
        return statusObj[status] || '-';
      },
    },
    type: {
      title: '商品类型',
      render: e => typeObj[e] || '-',
    },
    kind: {
      title: '商品类别',
      render: e => kindObj[e] || '-',
    },
    status: {
      title: '商品状态',
      render: e => statusObj[e] || '-',
    },
    NOINDEX_isRecommend: {
      title: '热门推荐',
      render: (e) => (
        <Switch
          checked={e.isRecommend === 1}
          checkedChildren='已推荐'
          unCheckedChildren='未推荐'
          onChange={(check) => handleUpdateIsrRecommend(e.id, check ? 1 : 0)}
        />
      ),
    },
    initStock: '原始库存',
    stock: '现有库存',
    NOINDEX_waitStart: {
      title: 'sku状态统计',
      render: e => {
        const { Skus } = e || [];
        let waitStartCount = 0;
        let startCount = 0;
        let startEndCount = 0;
        for (const sku of Skus) {
          if (sku.status == 20) waitStartCount++
          if (sku.status == 100) startCount++
          if ([110, 120].includes(sku.status)) startEndCount++
        }
        return `待开始${waitStartCount}; 进行中${startCount}; 已结束${startEndCount}`;
      },
    },
    Merchant: {
      title: '所属店铺',
      render: e => e.title || '-',
    },
    property: {
      title: '所属分类',
      render: e => {
        let result = parseJSON(e) || {};
        result = Object.entries(result)
          .map(i => i.join(':'))
          .join(';');
        return result;
      },
    },
    NOINDEX_startTime: {
      title: '开始时间',
      render: e => {
        const { Skus } = e || {};
        const startTime = Skus[0]?.startTime;
        const result = startTime ? toDateTime(startTime) : "-";
        return result;
      },
    },
    NOINDEX_endTime: {
      title: '结束时间',
      render: e => {
        const { Skus } = e || {};
        const endTime = Skus[0]?.endTime;
        const result = endTime ? toDateTime(endTime) : "-";
        return result;
      },
    },
    createdAt: {
      title: '创建时间',
      render: e => toDateTime(e),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          disabled={{
            offShelf: e.status !== 20,
          }}
          listData={{
            // select: () => window.open(`/spu/list/detail?i=${e.id}`),
            select: () => history.push(`/spu/list/detail?i=${e.id}`),
            offShelf: () => handleUpdate(e.id, -20),
            update: () => {
              const { ...prop } = e;
              const info = parseJSON(prop.info) || {};
              setVisible(true);
              setDatas({
                ...prop,
                describe: info.describe
              });
            },
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn, selectedRowKeys, setSelectedRowKeys } = useTable({
    choiceKey: "id",
    choiceType: 2,
    columns,
    API: getSpuList,
    isInit: false,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'id',
      label: '商品编号',
    },
    {
      id: 'name',
      label: '商品名称',
    },
    {
      id: 'merchantId',
      label: '店铺编号',
    },
    {
      id: 'title',
      label: '店铺名称',
    },
    {
      id: 'status',
      label: '商品状态',
      type: 'select',
      selects: statusObj,
    },
    {
      id: 'type',
      label: '商品类型',
      type: 'select',
      selects: typeObj,
    },
    {
      id: 'kind',
      label: '商品类别',
      type: 'select',
      selects: kindObj,
    },
    {
      id: 'isRecommend',
      label: '是否推荐',
      type: 'select',
      selects: recommendObj,
    },
    {
      id: 'times',
      label: '拍卖时间',
      type: 'rangeTime',
    },
    {
      id: 'createTime',
      label: '创建时间',
      type: 'rangeTime',
    },
  ];

  useEffect(() => {
    getSpuOver().then(res => {
      const countData = [
        ['认购数量', res.subscriptionCount],
        ['正在拍卖量', res.auctionCount],
        ['已流拍量', res.auctionTimeoutCount],
        ['待审核量', res.auditCount],
      ];
      setCount(countData);
    });
  }, []);

  const changeQuery = (value = {}) => {
    const { times, createTime, ...props } = value;
    const [start, end] = times || [];
    const [starts, ends] = createTime || [];
    const q = {
      ...props,
      ...(times && {
        startTime: toDateTime(start),
        endTime: toDateTime(end),
      }),
      ...(createTime && {
        createdStartTime: toDateTime(starts),
        createdEndTime: toDateTime(ends),
      }),
    };
    setQuery(q);
    flagFn(true);
  };

  const handleUpdateIsrRecommend = (id, isRecommend) => {
    const data = { ids: [id], isRecommend: isRecommend }
    postSpuUpdate({
      body: data,
    }).then(() => {
      message.success('操作成功');
      flagFn();
    });
  };

  const batchAudit = (status) => {
    console.log("selectedRowKeys", selectedRowKeys)
    const data = { ids: selectedRowKeys, status: status }
    postSpuUpdate({
      body: data,
    }).then(() => {
      message.success('操作成功');
      flagFn();
    })
  };

  return (
    <>
      <HeaderTitle />
      <OverItem datas={count} width={'25%'} />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <ExportData
            title="商品列表"
            API={getSpuList}
            query={query}
            extend={{
              status: statusObj,
              type: typeObj,
              kind: kindObj,
              Skus: info => {
                const arr = info.map(
                  i =>
                    `[起始价:${calcPrice(i.startPrice)},最终价:${calcPrice(
                      i.finalPrice
                    )},认购价:${calcPrice(i.subscriptionPrice)},结束时间:${toDateTime(
                      i.endTime
                    )},竞拍次数:${i.offerNums},竞拍人数:${i.offerCount}]`
                );
                return arr.join('');
              },
            }}
            columns={{
              id: '商品编号',
              name: '商品名称',
              thumb: '封面图',
              status: '商品状态',
              type: '商品类型',
              kind: '商品类别',
              Skus: '排期信息',
              'Merchant.id': '店铺编号',
              'Merchant.title': '所属店铺',
              property: '所属分类',
              'Spu.resellCount': '转拍次数',
              createdAt: '创建时间',
            }}
          />
        }
      />
      <Table {...tableProps} />
      <span style={{ marginRight: 8 }}>
        已选择 <b style={{ color: '#1890ff' }}>{selectedRowKeys.length}</b> 项
      </span>
      <Button
        onClick={() => { batchAudit(20) }}
        disabled={selectedRowKeys.length === 0}
      >
        批量通过
      </Button>
      <Button
        onClick={() => { batchAudit(-10) }}
        disabled={selectedRowKeys.length === 0}
      >
        批量拒绝
      </Button>
      {selectedRowKeys.length > 0 && (
        <Button type="link" onClick={() => setSelectedRowKeys([])}>
          清空选择
        </Button>
      )}
      <SpuEdit
        data={datas}
        visible={visible}
        onChange={res => {
          if (res) flagFn();
          setVisible(false);
          setDatas({});
        }}
      />
    </>
  );
}

export default SpuList;
